export default {
  textMap: {
    "边缘计算特征值": "Measurement",
    "分段柱状图": "Segmented Bar",
    "叶片频率": "Blade Freq",
    "趋势图": "Trend",
    "轨迹图": "Orbit",
    "瀑布图": "Waterfall",
    "全频谱瀑布图": "Full Spectrum Waterfall",
    "倒谱图": "Cepstrum",
    "包络": "Envelope",
    "使用当前时间": "Use Current Time",
    "放大": "Zoom In",
    "放大还原": "Reset Zoom",
    "还原到上一级": "Last Zoom",
    "导出": "Export",
    "全屏": "Full Screen",
    "退出全屏": "Exit Full Screen",
    "主游标": "Main-Cursor",
    "辅游标": "Auxiliary-Cursor",
    "标点": "Dot",
    "取消标点": "Un-dot",
    "自动寻峰": "Peak",
    "谐频": "Harmonic",
    "边频": "Side Frequency",
    "更多": "More",
    "阶次": "Order",
    "赫兹": "Hz",
    "标注": "Label",
    "取消标注": "Un-label",
    "清除": "Clear",
    "删除图谱": "Delete Graph",
    "历史概貌图": "Historical Overview",
    "显示报警线": "Show Thresholds",
    "隐藏报警线": "Hide Thresholds",
    "多参数分析波形图": "Multi-Waveform",
    "波形图": "Waveform",
    "频谱图": "Spectrum",
    "全频谱图": "Full Spectrum",
    "单值棒图": "Single Bar",
    "多值棒图": "Multi Bar",
    "图": "Graph",
    "进动方向": "Precession Direction",
    "正向": "Forward",
    "反向": "Reverse",
    "差量": "Offset",
    "天": "D",
    "时": "H",
    "秒": "S",
    "分": "Min",
    "多特征值": "Measurements",
    "气体载荷": "Gas Load",
    "惯性载荷": "Inertial Load",
    "活塞杆载荷": "Piston Rod Load",
    "振动波形": "Vibration Waveform",
    "活塞杆载荷监测": "Piston Rod Load",
    "幅值转速": "Amplitude Speed",
    "相位转速": "Phase Speed",
    "缸号": "Bank",
    'p-v图': 'P-V',
    'p-a图': 'P-A',
    'p-t图': 'P-T',
    'logP-logV图': 'logP-logV',
    "Y轴最小值输入": "Y-axis Minimum",
    "X轴最大值输入": "X-axis Maximum",
    "Y轴最大值输入": "Y-axis Maximum",
    "显示转速": "Display Speed",
    "隐藏转速": "Hide Speed",
    "趋势图时间单位": '[Time]',
    "波形图时间单位": '[S]',
    "暂无报警线信息": "Threshold unavailable",
    "高高报": "HH",
    "高报": "H",
    "低低报": "LL",
    "低报": "L",
    "输入字符非法，请重新输入" : "Invalid input, try again.",
    "已达到图谱数量显示上限": "Maximum number of graphs reached",
    "时间戳:": "TimeStamp:",
    "查询时间": "Query",
    "切换": "Switch",
    "转速": "Speed",
    "传统概貌图":"Traditional Overview",
    "设备概貌图": "Equipment",
    "工艺流程图": "Process",
    "柱状图": "Bar",
    "全级联图": "Full Cascade",
    "级联图": "Cascade",
    "轴心位置": "Shaft Position",
    "轴心轨迹": "Shaft Orbit",
    "操作页": "Operation Page",
    "开车": "Startup",
    "停车": "Shutdown",
    "未知": "Unknown",
    "总值": "ePk(Waveform)",
    "平均值": "Average(Waveform)",
    "整流平均值": "Rectified Average(Waveform)",
    "峰峰值": "Pk-Pk(Waveform)",
    "波形标准差": "Standard Deviation(Waveform)",
    "峭度因子": "Kurtosis(Waveform)",
    "脉冲因子": "Impulse(Waveform)",
    "波形因子": "Crest(Waveform)",
    "裕度因子": "Margin(Waveform)",
    "歪度因子": "Skewness(Waveform)",
    "峰值因子": "Peak(Waveform)",
    "高频总量": "Pk Sum(Hi-Freq)",
    "中频总量": "Pk Sum(Medium-Freq)",
    "低频总量": "Pk Sum(Lo-Freq)",
    "高频能量": "Energy(Hi-Freq)",
    "中频能量": "Energy(Medium-Freq)",
    "低频能量": "Energy(Lo-Freq)",
    "频谱有效值": "RMS(Spectrum)",
    "频谱均值": "Average(Spectrum)",
    "频率重心": "Centroid(Spectrum)",
    "频谱峰值": "Max(Spectrum)",
    "内圈幅值": "Pk(BPFI)",
    "外圈幅值": "Pk(FBFO)",
    "滚动体幅值": "Pk(BSF)",
    "保持架幅值": "Pk(FTF)",
    "特征选择": "Category",
    "全选": "All",
    "内圈特征频率": "BPFI",
    "外圈特征频率": "BPFO",
    "滚动体特征频率": "BSF",
    "保持架特征频率": "FTF",
    "内圈": "Inner",
    "外圈": "Outer",
    "滚动体": "Element",
    "保持架": "Cage",
    "转子条频率": "RBPF",
    "定子槽频率": "SSPF",
    "时域特征（幅值）": "Waveform(Basic)",
    "时域特征（指标）": "Waveform(Factor)",
    "频域特征（通频）": "Spectrum(Direct)",
    "频域特征（选频）": "Spectrum(Specific)",
    "故障特征频率": "Defect Frequency",
    "计算轴承": "Bearing Frequency",
    "轴承型号": "Bearing Model",
    "请输入正确的转速!": "Please enter the correct speed!",
    "滚动体直径或滚动轴承的节圆直径不能为0!": "The diameter of the rolling element or the pitch diameter of the rolling bearing cannot be 0!",
    "通频": "Direct",
    "1倍频幅值": "1X Amp",
    "2倍频幅值": "2X Amp",
    "3倍频幅值": "3X Amp",
    "1/2倍频幅值": "0.5X Amp",
    "自定义": "Custom",
    "过滤类型": "FilterType",
    "倍频幅值": "Order",
    "残振": "Residual Vibration",
    "峰值": "Pk",
    "峭度": "Kurtosis",
    "歪度": "Skewness",
    "最大值": "Max",
    "最小值": "Min",
    "压力": "Pressure",
    "振动": "Vibration",
    "温度": "Temperature",
    "流量": "Flow",
    "其它": "Others",
    "撞击": "Impact",
    "直流量": "DC",
    "有效值": "RMS",
    "平均压力": "Average Pressure",
    "机械效率": "Mechanical Efficiency",
    "吸气容积效率": "Suction Volumetric Efficiency",
    "排气容积效率": "Discharge Volumetric Efficiency",
    "单缸指示功率": "Cylinder Indicated Power",
    "压缩指数": "Compression Index",
    "膨胀系数": "Expansion Index",
    "实际压力比": "Pressure Ratio",
    "沉降量/偏摆量": "Average Position",
    "峰-峰值": "Pk-Pk",
    "活塞-气缸剩余间隙": "Piston-Cylinder Clearance",
    "一倍频幅值": "1X Amp",
    "二倍频幅值": "2X Amp",
    "间隙电压": "Gap Voltage",
    "加速度峰值": "Acc ePk",
    "加速度高频": "Acc Hi-Fq ePk",
    "加速度低频": "Acc Lo-Fq ePk",
    "加速度波形峭度": "Acc Kurtosis",
    "速度有效值": "Ve RMS",
    "通频gIE值": "gIE",
    "加速度真峰值": "Acc Pk",
    "通频有效值": "RMS",
    "1倍频有效值": "1X RMS",
    "2倍频有效值": "2X RMS",
    "3倍频有效值": "3X RMS",
    "1/2倍频有效值": "1/2 RMS",
    "残振有效值": "Residual RMS",
    "无线振动速度有效值": "Wireless Ve RMS",
    "无线振动位移峰值": "Wireless Disp Pk",
    "无线振动加速度有效峰值": "Wireless Acc ePk",
    "振动速度有效值": "Ve RMS",
    "振动加速度有效峰值": "Acc ePk",
    "振动加速度低频值": "Acc Lo-Fq ePk",
    "振动加速度真峰值": "Acc Pk",
    "振动位移峰峰值": "Disp PP",
    "1倍频相位": "1X Phase",
    "2倍频相位": "2X Phase",
    "3倍频相位": "3X Phase",
    "1/2倍频相位": "0.5X Phase",
    "寻峰个数:": "Peak Num:",
    "谐频倍数:": "Harmonic Num:",
    "缺陷频率:": "Defect Freq:",
    "叶片频率:": "Blade Freq:",
    "显示": "Show",
    "隐藏": "Hide",
    "事件描述:": "Event Description:",
    "输入事件内容": "Please enter the description for this event.",
    "事件查询": "Event Query",
    "图谱显示:": "Graph:",
    "分析线数:": "FFT Lines:",
    "比较类型:": "Type:",
    "径向振动": "Radial Vibration",
    "轴向位移": "Axial Displacement",
    "设备名称:": "Equipment:",
    "事件查询:": "EventQuery:",
    "类型选择:": "Sort by:",
    "请选择类型": "Select model",
    "请选择缸号": "Select Cylinder",
    "请选择图谱": "Select Graph",
    "请输入数字": "Please input a order number",
    "选择分析线数": "Select FFT lines",
    "趋势类型:": "Trend Type:",
    "图谱选择:": "Graph:",
    "图谱显示": "Trend",
    "时间选择:": "Timespan:",
    "模式选择:": "Data From:",
    "转速时间": "Speed Time",
    "波德图": "Bode",
    "相位时间": "Phase Time",
    "极坐标图": "Polar",
    "查询": "Query",
    "刷新": "Fresh",
    "停止": "Stop",
    "启停车日志:": "Event Log:",
    "事件id": "Event ID",
    "事件标记描述": "Event Description",
    "状态": "Status",
    "转速(r/min)": "Speed(RPM)",
    "日志": "Log",
    "开始时间:": "From:",
    "结束时间:": "To:",
    "使用": "Enable",
    "不使用": "Disable",
    "选择年月:": "Month:",
    "yyyy 年 MM 月": "MM/yyyy",
    "实时": "Real Time",
    "历史": "Historical",
    "参数区间:": "Parameter:",
    "选择测点:": "Points:",
    "全部": "All",
    "曲轴箱": "Crankcase",
    "1缸": "Cylinder 1",
    "2缸": "Cylinder 2",
    "3缸": "Cylinder 3",
    "4缸": "Cylinder 4",
    "5缸": "Cylinder 5",
    "6缸": "Cylinder 6",
    "趋势": "Trend",
    "波形": "Waveform",
    "频谱": "Spectrum",
    "缸号选择:": "Sort by:",
    '特征': 'Measurement',
    '壳体振动': 'Case Vibration',
    '曲轴箱振动': 'Crankcase Vibration',
    "其它振动": "Other Vibrations",
    '活塞杆沉降/偏摆': 'Rod Position',
    '动态压力': 'Dynamic Pressure',
    "启停车测点": "Radial Vibration",
    "振动-加速度": "Acceleration",
    "振动-位移": "Displacement",
    "振动-速度": "Velocity",
    "位移": "Displacement",
    "湿度": "Humidity",
    "加速度": "Acceleration ",
    "速度": "Velocity ",
    "撞击次数": "Impact Count",
    "温度测点": "Temperature",
    "压力测点": "Pressure",
    "流量测点": "Flow",
    "振动测点": "Radial Vibration",
    "轴心轨迹测点树关键字": "Channel Pair",
    "轴心位置测点树关键字": "Channel Pair",
    "频率": "Frequency",
    "相位": "Phase",
    "不同测点": "Multiple",
    "相同测点": "Single",
    "前一阶段": "Timespan",
    "起止时间": "From-To",
    "起止月": "Month",
    "前5分钟": "Last 5 mins",
    "前半小时": "Last 30 mins",
    "前1小时": "Last 60 mins",
    "前1天": "Last Day",
    "前1周": "Last Week",
    "前1月": "Last Month",
    "前1季度": "Last Season",
    "前1年": "Last Year",
    "时间选择错误": "Time selection error",
    "请确保开始时间早于终止时间": "End time should be later than start time",
    "确定": "Yes",
    '搜索组织结构': 'Search',
    '筛选设备类型': 'Filter Equipment Type',
    '旋转': 'Rotary Machinery',
    '燃气轮机': 'Gas Turbine',
    '往复': 'Reciprocating Machinery',
    '机泵': 'General Machinery(Wired)',
    '风电': 'Wind Turbine',
    '燃气发动机': 'Gas Engine',
    '内燃机': 'Internal Combustion Engine',
    '无线机泵': 'General Machinery(Wireless)',
    '组织机构': 'Organization',
    "旋转机械专用图谱": "Rotary Machinery",
    "振动监测": "Vibration",
    "机组概貌图": "Overview",
    "单多值棒图": "Bar",
    "温度分布场": "Temperature Distribution",
    "振动历史比较": "Vibration Comparison",
    "其它参数趋势图": "Static Parameters",
    "综合分析": "Comprehensive Analysis",
    "冲击诊断": "gIE",
    "轴心轨迹-菜单关键字": "Shaft Orbit",
    "轴心位置-菜单关键字": "Shaft Position",
    "全频谱图-菜单关键字": "Full Spectrum",
    "启停车图形": "Startup & Shutdown",
    "旋转报警查询": "Alarm Query",
    "参数比较查询": "Parameter Comparison Query",
    "运行状态图": "Multi-Trend",
    "倒谱图-菜单关键字": "Cepstrum",
    "往复机械专用图谱": "Reciprocating Machinery",
    "单值棒图-菜单关键字": "Bar",
    "历史比较图": "Vibration Comparison",
    "综合监测": "Integrated Monitor",
    "活塞杆沉降/偏摆监测-菜单关键字": "Piston Rod Position",
    "示功图": "Dynamic Pressure",
    "多参数分析-菜单关键字": "Multi-Waveform",
    "往复报警查询": "Alarm Query",
    "机泵报警查询": "Alarm Query",
    "趋势分析": "Vibration",
    "分析图谱": "Analysis Tools",
    "机泵专用图谱": "General Machinery(Wired)",
    "活塞杆载荷分析": "Piston Rod Load",
    "无线机泵专用图谱": "General Machinery(Wireless)",
    "波形频谱对比分析": "Vibration Comparison",
    "边缘计算特征值趋势图": "Measurement Trend",
    "报警查询": "Alarm Query",
    "语言": "Language",
    "中文": "Chinese",
    "英文": "English",
    "俄文": "Russian",
    "更改主题": "Change Theme",
    "静谧蓝": "Serenity",
    "默认": "Default",
    "暗黑": "Dark",
    "无数据": "No Data",
    "范围内无数据点": "No data within the period",
    "数据加载中": "Data Loading...",
    "数据获取失败": "Failed To retrieve data",
    "请选择事件": "Please select an Event",
    "缺陷频率无数据": "Defect frequency unavailable",
    "请输入标注": "Please enter the remark",
    "取消": "Cancel",
    "选择开始时间": "Select start time",
    "选择结束时间": "Select end time",
    "关注": "Follow",
    "取消关注": "Unfollow",
    "显示全部点": "All Points",
    "仅显示波形点": "Waveform Only",
    "仅显示长波形点": "Long Waveform Only",
    "X轴真峰值": "Pk(X)",
    "X轴有效峰值": "ePk(X)",
    "X轴有效值": "RMS(X)",
    "X轴峰峰值": "Pk-Pk(X)",
    "Y轴真峰值": "Pk(Y)",
    "Y轴有效峰值": "ePk(Y)",
    "Y轴有效值": "RMS(Y)",
    "Y轴峰峰值": "Pk-Pk(Y)",
    "Z轴真峰值": "Pk(Z)",
    "Z轴有效峰值": "ePk(Z)",
    "Z轴有效值": "RMS(Z)",
    "Z轴峰峰值": "Pk-Pk(Z)",
    "MCU温度": "MCU Temperature",
    "振动趋势图": "Vibration Trend",
    "转速趋势图": "Speed Trend",
    "X轴加速度": "Acceleration(X)",
    "Y轴加速度": "Acceleration(Y)",
    "Z轴加速度": "Acceleration(Z)",
    "无线toC设备专用图谱": "Wireless Analysis Kit",
    "补偿": "Data Compensation",
    "无": "No Compensation",
    "从数据库选择": "Select Dataset",
    "第一个样本": "First Dataset",
    "最后一个样本": "Last Dataset",
    "当前样本": "Current Dataset",
    "创建新数据集": "New Dataset",
    "未选中补偿点": "No dataset selected",
    "通频振动": "Direct Amp",
    "低压转子1X振动": "1X Amp(LP)",
    "低压转子2X振动": "2X Amp(LP)",
    "低压转子谐波振动": "Harmonic Amp(LP)",
    "高压转子1X振动": "1X Amp(HP)",
    "高压转子2X振动": "2X Amp(HP)",
    "高压转子谐波振动": "Harmonic Amp(HP)",
    "动力涡轮1X振动": "1X Amp(PT)",
    "动力涡轮2X振动": "2X Amp(PT)",
    "动力涡轮谐波振动": "Harmonic Amp(PT)",
    "低频残振": "Low-freq Residual Amp",
    "高频残振": "High-freq Residual Amp",
    "燃气轮机专用图谱": "Gas Turbine",
    "未选中补偿数据集": "No compensation dataset selected",
    "获取失败": "Failed to retrieve",
    "名称": "Name",
    "请输入名称": "Please enter a name for compensation data",
    "请选择子类型": "Please select a subtype",
    "至少选择一个补偿范围": "Please select at least one compensation range",
    "创建成功": "Created successfully",
    "创建失败": "Failed to create",
    "序号": "No.",
    "类型": "Type",
    "子类型": "Subtype",
    "时间戳": "Timestamp",
    "操作": "Action",
    "删除成功": "Deleted successfully",
    "删除失败": "Failed to delete",
    "设置成功": "Settings saved successfully",
    "设置失败": "Failed to save settings",
    "未选中样本": "No sample selected",
    "启动": "Startup",
    "停机": "Shutdown",
    "其他": "Other",
    "热": "Hot",
    "冷": "Cold",
    "矢量": "Vector",
    "间隙": "Gap",
    "补偿范围": "Compensation Scope",
    "保存": "Save",
    "数据导出": "Export Data",
    "包络波形": "Envelope waveform",
    "包络频谱": "Envelope spectrum",
    "包络方式": "Filter",
    "高通": "High Pass",
    "带通": "Band Pass",
    "截止频率": "Cutoff",
    "上截止频率": "Upper Cutoff",
    "下截止频率": "Lower Cutoff",
    "请输入截止频率": "Please enter the cutoff frequency.",
    "平均值（轴向位移）": "Average",
    "没有设置报警门限": "Alarm threshold not set",
    "断网": "Offline",
    "正常": "Normal",
    "智能一级": "AI Alarm I",
    "智能二级": "AI Alarm II",
    "智能三级": "AI Alarm III",
    "固定高报": "H Alarm",
    "固定高高报": "HH Alarm",
    '频谱瀑布图': 'Spectrum Waterfall',
    '峰值趋势': 'Peak Trend',
    '分析诊断': 'Analysis Tools',
    '时间': 'Time',
    '测点': 'MP',
    '趋势特征值': 'Mesurments Trend',
    '测量类型': 'Measurement Category',
    '特征类型': 'Measurement',
    '缓变量测点': 'Process MP',
    '平均值（特征值）': 'Average',
    '峰峰值（特征值）': 'ePk-Pk',
    'gIE值': 'gIE',
    '真峰值': 'Pk',
    '真峰峰值': 'Pk-Pk',
    '加速度冲击': 'Acc Shock',
    '振动趋势': 'Vibration Trend',
    '包络分析': 'Envelope Analysis',
    '缓变量趋势': 'Process Trend',
  },
};



// WEBPACK FOOTER //
// ./src/language/en.js